import styled from 'styled-components'
import { Button as ButtonMui } from '@mui/material'

export const Button = styled(ButtonMui)<{ $bgColor?: string, $hoverColor?: string, $letterColor?: string, $disabledColor?: string}>`
  color: ${({ $letterColor }) => $letterColor} !important;
  background-color: ${({ $bgColor }) => $bgColor} !important;

  &:hover {
    background-color: ${({ $hoverColor }) => $hoverColor} !important;
  }

  &:disabled {
    background-color: ${({ $disabledColor }) => $disabledColor} !important;
  }
`
